import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './subscription.css';

function Subscription() {
  const navigate = useNavigate();
  const [activeToggle, setActiveToggle] = useState('personal');

  const handleClose = () => {
    navigate(-1); // Go back to previous page
  };

  const handleSelectPlus = () => {
    // Navigate to dashboard with planner
    navigate('/dashboard?showPlanner=true');
  };

  const handleToggle = (type) => {
    setActiveToggle(type);
  };

  return (
    <div className="subscription-container">
      <div className="subscription-content">
        <button className="close-button" onClick={handleClose}>
          <i className="fas fa-times"></i>
        </button>

        <h1 className="subscription-title">Uppgradera ditt abonnemang</h1>

        <div className="subscription-toggle">
          <button 
            className={`toggle-button-subscription ${activeToggle === 'personal' ? 'active' : ''}`}
            onClick={() => handleToggle('personal')}
          >
            Personligt
          </button>
          <button 
            className={`toggle-button-subscription ${activeToggle === 'business' ? 'active' : ''}`}
            onClick={() => handleToggle('business')}
          >
            Business
          </button>
        </div>

        {activeToggle === 'personal' && (
          <div className="subscription-plans">
            <div className="plan-card">
              <h2 className="plan-name">Plus</h2>
              <div className="plan-price">
                <span className="currency">$</span>
                <span className="amount">20</span>
                <span className="period">USD/månad</span>
              </div>
              <p className="plan-description">
                Förbättra produktivitet och kreativitet med utökad åtkomst
              </p>
              <button className="plan-button current" onClick={handleSelectPlus}>
                Ditt nuvarande abonnemang
              </button>

              <div className="plan-features">
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Allt som ingår i Free</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Utökad användning av meddelanden, filöverföring, avancerad dataanalys och bildgenerering</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Standard- och avancerat röstläge</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Åtkomst till djup research, flera resonerande modeller (o3-mini, o3-mini-high och o1) samt en förhandsgranskning av GPT-4.5 för forskningsändamål</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Skapa och använd uppgifter, projekt och anpassade GPT:er</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Begränsad åtkomst till videogenerering med Sora</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Chansen att prova nya funktioner</span>
                </div>
              </div>

              <div className="plan-links">
                <a href="https://savewithpenny.tech/contact" className="plan-link">Hantera mitt abonnemang</a>
                <a href="https://savewithpenny.tech/contact" className="plan-link">Jag vill ha hjälp med ett fakturarelaterat problem</a>
              </div>
            </div>

            <div className="plan-card">
              <h2 className="plan-name">Pro</h2>
              <div className="plan-price">
                <span className="currency">$</span>
                <span className="amount">200</span>
                <span className="period">USD/månad</span>
              </div>
              <p className="plan-description">
                Få allt OpenAI har att erbjuda med den högsta åtkomstnivån
              </p>
              <button className="plan-button upgrade">
                Skaffa Pro
              </button>

              <div className="plan-features">
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Allt som ingår i Plus</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Obegränsad åtkomst till alla resonerande modeller och GPT-4o</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Obegränsad åtkomst till avancerat röstläge</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Utökad åtkomst till djup research, för komplexa uppgifter som kräver efterforskningar online i flera steg</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Åtkomst till förhandsgranskning av GPT-4.5 för forskningsändamål</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Åtkomst till pro-läge för o1, som använder mer beräkningskapacitet för att generera de bästa svaren på de svåraste frågorna</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Utökad åtkomst till videogenerering med Sora</span>
                </div>
              </div>

              <div className="plan-links">
                <a href="https://savewithpenny.tech/contact" className="plan-link">Jag vill ha hjälp med ett fakturarelaterat problem</a>
                <p className="plan-note">Obegränsade skyddsräcken mot att bli utsatt för otillåten användning. <a href="https://savewithpenny.tech/contact" className="plan-link">Läs mer</a></p>
              </div>
            </div>
          </div>
        )}

        {activeToggle === 'business' && (
          <div className="subscription-plans">
            <div className="plan-card">
              <h2 className="plan-name">Team</h2>
              <div className="plan-price">
                <span className="currency">$</span>
                <span className="amount">30</span>
                <span className="period">USD/användare/månad</span>
              </div>
              <p className="plan-description">
                För team som behöver samarbeta och dela resurser
              </p>
              <button className="plan-button upgrade">
                Skaffa Team
              </button>

              <div className="plan-features">
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Allt som ingår i Plus</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Administratörsverktyg för teamhantering</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Delade resurser och samarbetsverktyg</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Prioriterad support för team</span>
                </div>
              </div>
            </div>

            <div className="plan-card">
              <h2 className="plan-name">Enterprise</h2>
              <div className="plan-price">
                <span>Kontakta oss för prisuppgift</span>
              </div>
              <p className="plan-description">
                För organisationer som behöver avancerade säkerhets- och administrationsverktyg
              </p>
              <button className="plan-button upgrade">
                Kontakta försäljning
              </button>

              <div className="plan-features">
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Allt som ingår i Team</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Avancerade säkerhetsfunktioner</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Anpassad implementering och integration</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Dedikerad kundansvarig</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>SLA med garanterad upptid</span>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="subscription-footer">
          <div className="footer-icon">
            <i className="fas fa-users"></i>
          </div>
          <p>Behöver ditt företag fler funktioner?</p>
          <a href="https://savewithpenny.tech/contact" className="footer-link">Se ChatGPT Enterprise</a>
        </div>
      </div>
    </div>
  );
}

export default Subscription; 